// extracted by mini-css-extract-plugin
module.exports = {"container":"hT","title":"hU"};